import React from "react";
import { Link } from "react-router-dom";

export default function Logo({ size = 28, showTagline = false, testId = "dt6-logo" }) {
  return (
    <Link to="/" data-testid={testId} className="inline-flex items-center gap-2 no-underline">
      <span
        className="font-heading font-black tracking-tight"
        style={{ fontSize: size, color: "var(--dt6-text)", lineHeight: 1 }}
      >
        DT<span style={{ color: "var(--dt6-primary)" }}>6</span>
      </span>
      {showTagline && (
        <span className="font-mono text-[0.65rem] tracking-[0.2em] uppercase text-[color:var(--dt6-muted)]">
          / DATA_INFRA
        </span>
      )}
    </Link>
  );
}
